// Module
var code = "<div class=\"navbar-form navbar-left\" ng-transclude> </div>";
// Exports
module.exports = code;